import DGElement from "./DGElement.m"

import { 
    EMETLContext, 
} from "./Contexts/AppContext"

import DGAmplify, {
    DGAmplifyTools,
} from "./Databases/DGAmplify.m"

class DGUtility extends DGElement {

    /*** Private Members ***/
    
    /*** Protected Members ***/
    _ctx: EMETLContext
    /**
     * The database instance and backend data functions
     * 
     * @member {DGAmplifyTools} db
     */
    #db: DGAmplifyTools

    /**
     * The user (Amplify cognito user type)
     * 
     * @member 
     */
    #user
    
    /*** Private Methods ***/

    /**
     * @param {DGAmplifyTools} db - The firebase tools instance
     * @see DGAmplifyTools
     */
    private initializeDB = (db: DGAmplifyTools) => {
        this.db = db
    }
    
    /*** Protected Methods ***/
    
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        this.initializeDB(DGAmplify)
    }
        
    /*** Public Methods ***/
    
    public constructor() {
        super()
        this._init()
    }
    
    /**
     * Averages an array of numbers
     * 
     * @param {number[]} arr - an array of numbers to average
     * @returns {number} - the average of the elements in the array
     */
    
    public avg = (arr: number[]): number => arr.reduce((a,b) => (a+b)) / arr.length

    /**
     * @returns {DGAmplifyTools} - The value of the db private member
     * @see DGAmplifyTools
     */
    public getDB = (): DGAmplifyTools => {
        return this.db
    }

    public set user(user) {
        this.#user = user
    }

    public get user() {
        return this.#user
    }

    public set db(db: DGAmplifyTools) {
        this.#db = db
    }

    public get db(): DGAmplifyTools {
        return this.#db
    }

    public set ctx(ctx: EMETLContext) {
        this._ctx = ctx
    }

    public get ctx(): EMETLContext {
        return this._ctx
    }
}

export default DGUtility
